'use client'

import { Text } from '@/components/ui/text'
import { useMap, useMapProps } from './use-map'

export type MapProps = useMapProps

const Map = (props: MapProps) => {
  const { ref, styles, mapId, address } = useMap(props)

  return (
    <section className={styles.base()}>
      {!!address && (
        <div className={styles.container()}>
          <header className={styles.heading()}>
            <Text
              as="h2"
              size="heading-sm"
              weight="medium"
              className={styles.title()}
            >
              Localização
            </Text>
            <Text
              as="p"
              size="body-lg"
              weight="medium"
              className={styles.address()}
            >
              {address}
            </Text>
          </header>
        </div>
      )}
      <div ref={ref} id={mapId} className={styles.map()} />
    </section>
  )
}

export default Map
